import {
    PaymentForm,
    GetPaymentUrlForm,
    PrepareRefundOptions,
    PrepareRefundCreationForm,
    RefundExecutionForm,
    FindPaymentsQuery,
    PaymentViewModel,
    GetReportQuery,
    ReportResponse,
    FindPreOperationQuery,
    PreOperationViewModel,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/payment';

export class BillingApi {
    public static async payment(params: PaymentForm): Promise<void> {
        await axios.post(BASE_URL, params);
    }

    public static async generatePaymentUrl(params: GetPaymentUrlForm): Promise<string> {
        const res = await axios.post(`${BASE_URL}/url`, params);
        return res.data.paymentUrl;
    }

    public static async prepareRefund(params: PrepareRefundCreationForm): Promise<PrepareRefundOptions> {
        const res = await axios.post(`${BASE_URL}/refund`, params);
        return res.data;
    }

    public static async refund(operationId: string, params: RefundExecutionForm): Promise<void> {
        await axios.post(`${BASE_URL}/refund/${operationId}/execute`, params);
    }

    public static async abortRefund(operationId: string): Promise<void> {
        await axios.post(`${BASE_URL}/refund/${operationId}/abort`);
    }

    public static async closeShift(organizationId: string, workplaceId?: string): Promise<void> {
        await axios.post(`${BASE_URL}/close-shift`, {
            organizationId,
            workplaceId,
        });
    }

    public static async xReport(organizationId: string, workplaceId?: string): Promise<void> {
        await axios.post(`${BASE_URL}/x-report`, {
            organizationId,
            workplaceId,
        });
    }

    public static async find(params: FindPaymentsQuery): Promise<PaymentViewModel[]> {
        const res = await axios.get(BASE_URL, { params });
        return res.data.payments;
    }

    public static async getReport(params: GetReportQuery): Promise<ReportResponse> {
        const res = await axios.get(`${BASE_URL}/report`, { params });
        return res.data;
    }

    public static async getPreOperationList(params: FindPreOperationQuery): Promise<PreOperationViewModel[]> {
        const res = await axios.get(`${BASE_URL}/preoperation`, { params });
        return res.data.preOperations;
    }

    public static async retryPreOperation(paymentId: string): Promise<void> {
        await axios.post(`${BASE_URL}/preoperation/${paymentId}`);
    }
}
